var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "booking-block",
    {
      staticClass: "booking-block--payment",
      style: { opacity: _vm.paymentwindowReady ? "1" : "0" },
      attrs: {
        editMode: true,
        title: _vm.translations.header,
        subTitle: _vm.translations.sub_header,
        isCollapsed: false,
        valid: !_vm.isNotValid,
        showSaveBtn: false,
        showEditBtn: false
      }
    },
    [
      _c(
        "template",
        { slot: "edit" },
        [
          _c("iframe", {
            staticStyle: { width: "100%" },
            attrs: {
              id: "paymentFrame",
              name: "paymentFrame",
              frameborder: "0",
              height: "600px",
              src: _vm.paymentFrameworkUrl
            }
          }),
          _vm._v(" "),
          _vm._l(_vm.paymentNotes, function(note, key) {
            return _c("msg-box", { key: key, attrs: { type: "info" } }, [
              _c("p", { domProps: { textContent: _vm._s(note.text) } })
            ])
          })
        ],
        2
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c7feb15", { render: render, staticRenderFns: staticRenderFns })
  }
}